// extracted by mini-css-extract-plugin
export default {"gridPrice":"ZCg8J","gridPriceSpaced":"c6Kmp","priceAndDiscount":"eS10x"};